export default __webpack_public_path__ + "static/media/goal.3ecc792e.svg";